import { queries } from "../../shared/queries";
import { managedAiProviderLocked } from "../components/useSessionBootstrap";
import { config } from "../environment";
import { useQuery } from "./useQuery";

// The environment-managed AI provider and its per-tenant disable state:
// `locked` when the deployment forces it off (not admin-changeable), `disabled`
// when either the lock or the tenant admin toggle turns it off.
// `availableProvider` is undefined while disabled, so defaults and model
// pickers skip it.
export function useManagedAIProvider() {
  const managedProvider = config.managedAIProvider;
  const locked = managedAiProviderLocked();
  const [tenant] = useQuery(queries.currentTenant());
  const disabled = locked || tenant?.managedAiProviderDisabledAt != null;
  return {
    managedProvider,
    locked,
    disabled,
    availableProvider: disabled ? undefined : managedProvider,
  };
}
